import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span class="purple">Kanav Chugh </span>
            from <span class="purple">Sunnyvale, California, United States.</span>
            <br /><br />
            I work as a <span class="purple">Silicon Architecture Engineer</span> at <span class="purple">AMD</span>, where I drive 
            systems integration for Versal SoCs, architecting SystemVerilog RTL and Vitis HLS IPs for FPGAs used by thousands of embedded and data center customers.
            <br /><br />
            Previously, I've had the opportunity to work at <span class="purple">Google</span>, <span class="purple">ARPA-H</span> (Georgia Tech's EIC Lab), 
            and <span class="purple">Twistient</span>, focusing on post-silicon bring-up, SoC architecture for medical implants, and neuromorphic chip design. 
            <br /><br />
            Apart from engineering and coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Guitar
            </li>
            <li className="about-activity">
              <ImPointRight /> Tennis
            </li>
            <li className="about-activity">
              <ImPointRight /> Running
            </li>
            <li className="about-activity">
              <ImPointRight /> Kickboxing
            </li>
            
          </ul>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
